import Vision360Page from "@/features/vision-360/layouts/index";

export const Vision360 = () => {
  return <Vision360Page />;
};

export default Vision360;
